import React from "react";
import { elementType, node, oneOfType, string } from "prop-types";
import TabItem from "../../Tabs/Item";

export const context = React.createContext({ active: null, setActive: () => {} });

const SmartTabs = ({ initialActiveTab, children }) => {
	const [active, setActive] = React.useState(initialActiveTab);

	return <context.Provider value={{ active, setActive }}>{children}</context.Provider>;
};

SmartTabs.propTypes = {
	initialActiveTab: string,
	children: node,
};

const SmartTab = ({ id, Component = TabItem, ...props }) => {
	const { active, setActive } = React.useContext(context);

	const openTab = React.useCallback(
		event => {
			event.preventDefault();
			setActive(id);
		},
		[id, setActive],
	);

	return <Component active={id === active} onClick={openTab} {...props} id={id} />;
};

SmartTab.propTypes = {
	id: string,
	children: node,
	className: string,
	Component: oneOfType([string, elementType]),
	cell: string,
};

const SmartTabBody = ({ id, children }) => (
	<context.Consumer>{({ active }) => active === id && children}</context.Consumer>
);

SmartTabBody.propTypes = {
	id: string,
	children: node,
};

const MountedTabBody = ({ id, children, Component }) => (
	<context.Consumer>
		{({ active }) => (
			<Component style={{ display: active === id ? "block" : "none" }}>{children}</Component>
		)}
	</context.Consumer>
);

MountedTabBody.propTypes = {
	id: string,
	children: node,
	Component: oneOfType([string, elementType]).isRequired,
};

SmartTabBody.Mounted = MountedTabBody;

SmartTabs.Tab = SmartTab;
SmartTabs.TabBody = SmartTabBody;

export default SmartTabs;
